<template>
  <div class="div-container" :class="{ 'div-container-inner': tabChoosed == '内饰' }"
    :style="{ backgroundImage: tabChoosed === '内饰'&& !isPortrait ? `url(${bgImg})`:`unset`,backgroundColor: tabChoosed === '内饰'&& isPortrait || tabChoosed=='外观' ? `${bgColor}`:`unset` }">
    <!-- <div class="preLoad">
      <img :src="origin + '/assets/~/media/images/vehicle/ev5/vehicle/model/ebb.png'" alt="">
      <img :src="origin + '/assets/~/media/images/vehicle/ev5/vehicle/model/ebd.png'" alt="">
      <img :src="origin + '/assets/~/media/images/vehicle/ev5/vehicle/model/fn.png'" alt="">
      <img :src="origin + '/assets/~/media/images/vehicle/ev5/vehicle/model/ieb.png'" alt="">
      <img :src="origin + '/assets/~/media/images/vehicle/ev5/vehicle/model/ieg.png'" alt="">
      <img :src="origin + '/assets/~/media/images/vehicle/ev5/vehicle/model/isg.png'" alt="">
      <img :src="origin + '/assets/~/media/images/vehicle/ev5/vehicle/model/ism.png'" alt="">
      <img :src="origin + '/assets/~/media/images/vehicle/ev5/vehicle/model/ova.png'" alt="">
      <img :src="origin + '/assets/~/media/images/vehicle/ev5/vehicle/innerouter/inner/pics/img1.png'" alt="">
      <img :src="origin + '/assets/~/media/images/vehicle/ev5/vehicle/innerouter/inner/pics/img2.png'" alt="">
      <img :src="origin + '/assets/~/media/images/vehicle/ev5/vehicle/innerouter/inner/pics/img3.png'" alt="">
    </div> -->
    <div class="title" >Vehicle</div>
    <div class="top">
      <div class="car" @click="isShowCarList = !isShowCarList">
        <div class="car-name">
          <span class="car-name-pre">Sonet</span>
          <!-- {{ carChoosed.name }} -->
          <!-- <i class="el-icon-arrow-down jiantou" :class="{ 'open': isShowCarList }"></i> -->
          <!-- <div class="car-list" :class="{ 'open': isShowCarList }">
            <div class="car-list-item" v-for="item in carsList" :key="item.name" @click.stop="chooseCar(item)"><span
                class="pre">EV6</span>{{ item.name }}</div>
          </div> -->
        </div>
      </div>
      <div class="tab">
        <div class="tab-item" :class="[{'tab-item-active': item == tabChoosed},innerChoosed.name == '黑灰内饰' ? 'fontBlack':'']" v-for="item in tabsList" :key="item"
          @click="chooseTab(item)" :code-stm="`event, PAGEURL页面, 外观/内饰切换类型_${item}`" :style="tabChoosed == '内饰'?'color:#fff':''">{{ item }}</div>
      </div>
    </div>
    <img :src="origin + carImg" alt="" class="car-img" v-if="tabChoosed == '外观'">
    <img :src="bgImg" alt="" class="car-img" v-if="tabChoosed == '内饰' && isPortrait">
    <div class="bottom">
      <div class="color" v-if="tabChoosed == '外观' || !isPortrait">
        <div class="color-name">{{ colorChoosed.name }}</div>
        <div class="color-box">
          <div class="color-box-item" v-for="item in colorsList" :key="item.name" @click="chooseColor(item,'click')" :code-stm="`event, PAGEURL页面, 外观颜色_${item.name}`"
            :style="{ backgroundImage: `URL(${origin + item.icon})` }">
            <i class="el-icon-check" v-if="item.name == colorChoosed.name"
              :style="{ color: item.name != '珍珠白' ? '#fff' : '#000' }"></i>
          </div>
        </div>
      </div>
      <div class="inner" v-if="tabChoosed == '内饰' || !isPortrait">
        <div class="inner-name">内饰颜色：{{ innerChoosed.name }}</div>
        <div class="inner-box">
          <div class="inner-box-item" v-for="item in innerList" :key="item.name" @click="chooseInner(item,'click')" :code-stm="`event, PAGEURL页面, 内饰颜色_${item.name}`"
            :style="{ backgroundImage: `URL(${origin + item.icon})` }">
            <i class="el-icon-check" v-if="item.name == innerChoosed.name"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="tip">*画面中车型图片仅供参考，具体以当地授权经销商店内实际销售车型为准</div>
  </div>
</template>

<script>
import { isPortraitFun, getUrlKey, isPc } from "@/utils/utils.js";
export default {
  data() {
    return {
      isPortrait: isPortraitFun(),
      isPC: isPc(),
      isShowCarList: false,
      carsList: [
        {
          name: "GT",
          colorsList: [
            {
              name: '珍珠白',
              icon: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/outer/zhenzhubai-icon.png',
              img: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/outer/zhenzhubai.png',
              imgmob: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/outer/zhenzhubaimob1.png',
              color:'#ffffff'
            },
            {
              name: '极光黑',
              icon: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/outer/black-icon.png',
              img: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/outer/jiguanghei.png',
              imgmob: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/outer/jiguangheimob.png',
              // color:'#32353BB2'
              color:'#ffffff'
            },
            {
              name: '橄榄绿',
              icon: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/outer/ganlanlv-icon.png',
              img: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/outer/ganlanlv.png',
              imgmob: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/outer/ganlanlvmob1.png',
              // color:'#30403399',
              color:'#ffffff'
            },
            {
              name: '跃动红（黑顶/双色）*选装',
              icon: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/outer/yuedonghong-icon.png',
              img: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/outer/yuedonghong.png',
              imgmob: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/outer/yuedonghongmob1.png',
              // color:'linear-gradient(180deg, #b70007,#690005)',
              // colorImg: 'linear-gradient(180deg, #b70007,#690005)'
              color:'#ffffff'
            },
            {
              name: '珍珠白（黑顶/双色）*选装',
              icon: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/outer/zhengzhubaishungse-icon.png',
              img: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/outer/zhenzhubaishuangse.png',
              imgmob: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/outer/zhenzhubaimob.png',
              // color:'#32353B66',
              color:'#ffffff'
            }
          ],
          innerList: [
            {
              name: '黑色内饰',
              icon: '/assets/~/media/images/vehicle/ev5/vehicle/innerouter/inner/icon/heiseneishi-icon.png',
              img: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/inner/heiseneishipc.jpg',
              imgmob:'/assets/~/media/images/vehicle/sonet/mainpage/innerouter/inner/heihuineishimob.jpg',
            },
            {
              name: '黑灰内饰',
              icon: '/assets/~/media/images/vehicle/ev5/vehicle/innerouter/inner/icon/huiheineishi-icon.png',
              img: '/assets/~/media/images/vehicle/sonet/mainpage/innerouter/inner/huiheineishipc.jpg',
              imgmob:'/assets/~/media/images/vehicle/sonet/mainpage/innerouter/inner/huiheineishi-mob.jpg',
            }
          ],
        },
      ],
      carChoosed: {},
      carBgImg: require('../assets/images/ev6/out-inner-bg.png'),
      bgImg: require('../assets/images/ev6/out-inner-bg.png'),
      bgColor:'#c1c0c0',
      tabsList: ["外观", "内饰"],
      tabChoosed: "外观",
      colorsList: [],
      colorChoosed: "",
      carImg: "",
      innerList: [],
      innerChoosed: {},
      innerImg: "",
      origin: "",
      bgCarColor: "",
    };
  },
  watch: {
    carChoosed(n) {
      console.log(n);
      this.colorsList = this.carChoosed.colorsList
      this.innerList = this.carChoosed.innerList
      this.innerChoosed = this.innerList[0]
      if (this.tabChoosed == "外观") {
        this.chooseColor(this.colorsList[0])
      } else {
        this.chooseInner(this.innerList[0])
      }
    }
  },
  mounted: function () {
    console.log(process.env.NODE_ENV);
    if (process.env.NODE_ENV == "production") {
      this.origin = "https://www.kia.cn"
    }
    this.carChoosed = this.carsList[0]
  },
  methods: {
    chooseTab(item) {
      this.tabChoosed = item;
      if (item == "内饰") {
         this.bgColor = '#c1c0c0'
        console.log(this.bgColor);
        this.chooseInner(this.innerChoosed)
      } else {
        this.chooseColor(this.colorChoosed)
      }
      this.maidian(`索奈车型页-外观内饰组件-tab选择-${item}`)
    },
    chooseColor(item,type) {
      this.colorChoosed = item
      // console.log(item)
      this.carImg = this.isPortrait ? item.imgmob : item.img
      this.tabChoosed = "外观"
      //this.bgImg = this.carBgImg
      this.bgColor = item.color
      if (type == 'click') {
        this.maidian(`索奈车型页-外观内饰组件-颜色选择-${item.name}`)
      }
    },
    chooseInner(item,type) {
      this.innerChoosed = item
      this.innerImg = this.isPortrait ? item.imgmob : item.img
      this.bgImg = this.origin + this.innerImg
      this.tabChoosed = "内饰"
      if (type == 'click') {
        this.maidian(`索奈车型页-外观内饰组件-内饰选择-${item.name}`)
      }
    },
    chooseCar(item) {
      if (!this.isShowCarList) {
        return
      }
      this.carChoosed = item
      this.isShowCarList = false
      this.maidian(`索奈车型页-外观内饰组件-选择车款-索奈 ${item.name}`)
    },
    maidian(item) {
      console.log('埋点', item);
      try {
        stm_clicki("send", "event", window.location.href + '页面', "点击", item);
      } catch (e) {
        console.error(e);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
$screen_pc: 1920;

@function rempc($px) {
  @return ($px/$screen_pc)*100+vw;
}

.div-container {
  width: 100%;
  height: 100%;
  padding: 4.51vw 11.30vw;
  box-sizing: border-box;
  position: relative;
  background-size: cover;

  .preLoad {
    opacity: 0;
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .title {
    color: #000;
    font-size: rempc(18);
    font-weight: 600;
    line-height: rempc(28);
  }

  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    width: calc(100% - 22.6vw);
    z-index: 9;

    .car {
      position: relative;

      &-name {
        color: #000;
        font-size: rempc(48);
        line-height: rempc(72);
        display: flex;
        align-items: center;
        cursor: pointer;

        &-pre {
          font-weight: 600;
          margin-right: rempc(10);
        }

        .jiantou {
          width: rempc(48);
          margin-left: rempc(10);
          transition: transform 0.3s ease;
          transform: rotate(0deg);
          font-weight: 600;

          &.open {
            transform: rotate(180deg);
          }
        }

      }

      &-list {
        position: absolute;
        top: rempc(72);
        width: rempc(238);
        border-radius: rempc(10) rempc(10);
        background: #fff;
        cursor: auto;
        overflow: hidden;
        opacity: 0;
        transform: translateY(-10%);
        transition: all .5s;

        &.open {
          opacity: 1;
          transform: translateY(10%);

          .car-list-item {
            cursor: pointer;
          }
        }

        &-item {
          padding: 0 rempc(20);
          height: rempc(60rem);
          line-height: rempc(60);
          cursor: auto;
          font-size: rempc(32);


          .pre {
            margin-right: rempc(10);
            font-weight: 600;
          }

          &:hover {
            background: #000;
            color: #fff;
          }
        }
      }
    }

    .tab {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: rempc(32);
      line-height: rempc(48);
      color: #000;

      &-item {
        padding: rempc(4) 0 0;
        cursor: pointer;
        margin-right: rempc(32);
        font-family: xihei;

        &:last-child {
          margin-right: 0;
        }

        &-active {
          font-family: chuhei;
          position: relative;

          &::before {
            content: "";
            width: 100%;
            height: rempc(4);
            background-color: #000;
            position: absolute;
            top: rempc(-10);
            left: 0;
          }
        }
      }
    }
  }

  .bottom {
    width: calc(100% - 22.6vw);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    top:81.5vh;

    .color,
    .inner {
      &-name {
        color: #000;
        font-family: chuhei;
        font-size: rempc(18);
        line-height: rempc(28);
        margin-bottom: rempc(16);
      }

      &-box {
        display: flex;

        &-item {
          margin-right: rempc(16);
          width: rempc(45);
          height: rempc(45);
          // border: 0.5px solid #c3c7c9;
          border-radius: 50%;
          background-size: cover;
          position: relative;
          cursor: pointer;

          .el-icon-check {
            color: #fff;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: rempc(30);
            font-weight: bold;
          }

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .inner-box {
      justify-content: flex-end;
    }
  }

  .tip {
    color: #000;
    font-size: rempc(12);
    line-height: rempc(18);
    position: absolute;
    right: 11vw;
    top: 78.5vh
  }

  .car-img {
    width: rempc(1513);
    height: rempc(509);
    position: absolute;
    z-index: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    user-select: none;
  }

  &-inner {
    color: #fff;

    .title {
      color: #fff;
    }

    .top {
      .car-name {
        color: #fff;

        .car-list-item {
          color: #05141F;

          &:hover {
            color: #fff;
          }
        }
      }

      .tab {
        color: #fff;

        &-item {
          &::before {
            background-color: #fff;
          }
        }
      }
    }

    .bottom {

      .color-name,
      .inner-name {
        color: #fff;
      }
      // .color-name.fontBlack{
      //   color:#000;
      // }
      // .inner-name.fontBlack{
      //   color:#000;
      // }

    }

    .tip {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  @media (max-width: 768px) {
    height: 100vh;
    padding: 68px 20px;
    background-position: 56%;

    .title {
      font-size: 14px;
      line-height: 100%;
    }

    .top {
      width: calc(100% - 40px);
      margin-top: 8px;

      .car {
        &-name {
          font-size: 24px;
          line-height: 30px;

          &-pre {
            font-weight: 600;
            margin-right: 5px;
          }

          .jiantou {
            width: 24px;
            margin-left: 5px;
          }
        }

        &-list {
          top: 30px;
          width: 150px;
          border-radius: 5px;

          &-item {
            padding: 0 10px;
            height: 30px;
            line-height: 30px;
            font-size: 16px;

            .pre {
              margin-right: 5px;
            }
          }
        }
      }

      .tab {
        font-size: 18px;
        line-height: 26px;

        &-item {
          padding: 4px 0 0;
          margin-right: 16px;

          &-active {
            &::before {
              height: 2px;
            }
          }
        }
      }
    }

    .bottom {
      width: calc(100% - 40px);
      top: unset;
      bottom: 52px;

      .color,
      .inner {
        &-name {
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 10px;
        }

        &-box {
          &-item {
            margin-right: 12px;
            width: 32px;
            height: 32px;

            .el-icon-check {
              font-size: 18px;
            }
          }
        }
      }

      .inner-box {
        justify-content: flex-start;
      }
    }

    .tip {
      width: 242px;
      height: 44px;
      flex-shrink: 0;
      text-align: right;
      font-size: 10px;
      line-height: 14px;
      right: 20px;
      top: unset;
      bottom: 126px;
    }

    .c {
      width: 100%;
      height: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -60%);
      user-select: none;
    }
    .car-img {
      width: 100%;
      height: auto;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -60%);
      user-select: none;
    }
  }
}
.fontBlack{
  color:#000;
}
.div-container .tip.fontBlack{
  color:#000;
}
.div-container-inner .title.fontBlack{
  color:#000;
}
.div-container-inner .top .fontBlack::before{
  background-color:#000;
}
</style>
